import { render, staticRenderFns } from "./AppointmentNote.vue?vue&type=template&id=a46ed768&"
import script from "./AppointmentNote.vue?vue&type=script&lang=js&"
export * from "./AppointmentNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports